import Layout from '@/layouts/EmptyLayout'
export default [{
    path: '/bonuses',
    name: 'bonuses',
    meta: {
      layout: 'main'
    },
  component: () => import('@/views/bonuse/index')
    
  }]
